import isNumeric from './is-numeric.js';

export const sortMilestones = ( milestones ) => {
    return milestones.sort( ( a, b ) => {
        if ( a.countryCode === b.countryCode ) {
            if ( a.maxAward === b.maxAward ) {
                return ( a.milestoneCode || '' ).localeCompare( b.milestoneCode || '', undefined, {
                    numeric: isNumeric( a.milestoneCode ) && isNumeric( b.milestoneCode )
                } );
            }
            return a.maxAward - b.maxAward ;
        } else if ( a.countryCode && b.countryCode ) {
            return a.countryCode.localeCompare( b.countryCode );
        } else {
            if ( a.maxAward === b.maxAward ) {
                return ( a.milestoneCode || '' ).localeCompare( b.milestoneCode || '', undefined, {
                    numeric: isNumeric( a.milestoneCode ) && isNumeric( b.milestoneCode )
                } );
            }
            return a.maxAward - b.maxAward ;
        }
    } );
};

export const getMessageLevelLabelKey  = ( milestone ) => `program_${ milestone.programId }.level_${ milestone.milestoneCode.replace( / /g, '_' ) }_${ milestone.countryCode || '' }.description`;
export const getMilestoneNameKey = ( milestone ) => `program_${ milestone.programId }.level_${ milestone.milestoneCode.replace( / /g, '_' ) }_${ milestone.countryCode || '' }.label`;
